<template>
    <v-container class="py-12">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span class="page-title">{{ page.title }}</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›"
                            :items="dataset.breadcrumbItems"></v-breadcrumbs>
                    </div>
                    <div class="button-group">
                        <v-btn id="btnSave" type="button" elevation="0" color="primary" dark @click="save"
                            :loading="dataset.loading" v-if="page.isNew">Salvar</v-btn>
                        <v-btn id="btnSave" type="button" elevation="0" color="primary" dark @click="update"
                            :loading="dataset.loading" v-if="!page.isNew">Atualizar</v-btn>
                        <v-btn id="btnBack" type="button" elevation="0" color="primary" outlined
                            to="/manutencoes/corretivas">Voltar</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-form ref="form" v-model="dataForm.validForm">
            <v-row>
                <v-col cols="12">
                    <v-card class="card-form-outlined">
                        <v-card-title class="card-group-title">Informações gerais</v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-select dense outlined label="Veículo" :items="resources.vehicles"
                                        :item-text="vehicleLabel" item-value="id" v-model="dataset.data.vehicle_id"
                                        :rules="[$rules.required]" hide-details="auto"></v-select>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-select dense outlined label="Fornecedor" :items="resources.suppliers"
                                        item-text="name" item-value="id" v-model="dataset.data.supplier_id" clearable
                                        hide-details="auto"></v-select>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="4">
                                    <v-select dense outlined label="Tipo de manutenção"
                                        :items="resources.maintenanceTypes" item-text="label" item-value="value"
                                        v-model="dataset.data.maintenance_type" clearable
                                        hide-details="auto"></v-select>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-select dense outlined label="Status" :items="resources.statuses"
                                        item-text="label" item-value="value"
                                        v-model="dataset.data.maintenance_status"
                                        hide-details="auto"></v-select>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field dense outlined type="number" label="Hodômetro (KM)"
                                        v-model="dataset.data.odometer" min="0" hide-details="auto"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-text-field dense outlined type="datetime-local" label="Data início"
                                        v-model="dataset.data.started_at" hide-details="auto"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field dense outlined type="datetime-local" label="Data fim"
                                        v-model="dataset.data.finished_at" hide-details="auto"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12">
                    <v-card class="card-form-outlined">
                        <v-card-title class="card-group-title">Custos</v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-text-field dense outlined type="number" prefix="R$" label="Mão de obra"
                                        v-model="dataset.data.labor_cost" min="0" step="0.01"
                                        hide-details="auto"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field dense outlined type="number" prefix="R$" label="Custo externo"
                                        v-model="dataset.data.external_cost" min="0" step="0.01"
                                        hide-details="auto"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12">
                    <v-card class="card-form-outlined">
                        <v-card-title class="card-group-title">Descrição do serviço</v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12">
                                    <v-textarea dense outlined label="Problema reportado"
                                        v-model="dataset.data.reported_issue" rows="2" auto-grow
                                        hide-details="auto"></v-textarea>
                                </v-col>
                                <v-col cols="12">
                                    <v-textarea dense outlined label="Diagnóstico"
                                        v-model="dataset.data.diagnosis" rows="2" auto-grow
                                        hide-details="auto"></v-textarea>
                                </v-col>
                                <v-col cols="12">
                                    <v-textarea dense outlined label="Serviço executado"
                                        v-model="dataset.data.work_performed" rows="2" auto-grow
                                        hide-details="auto"></v-textarea>
                                </v-col>
                                <v-col cols="12">
                                    <v-textarea dense outlined label="Observações"
                                        v-model="dataset.data.notes" rows="2" auto-grow
                                        hide-details="auto"></v-textarea>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12">
                    <v-card class="card-form-outlined">
                        <v-card-title class="card-group-title d-flex justify-space-between align-center">
                            <span>Peças utilizadas</span>
                            <v-btn small elevation="0" color="primary" @click="addPartRow">
                                <v-icon small left>mdi-plus</v-icon>
                                Adicionar peça
                            </v-btn>
                        </v-card-title>
                        <v-card-text>
                            <v-simple-table dense v-if="dataset.data.parts && dataset.data.parts.length">
                                <thead>
                                    <tr>
                                        <th class="text-left" style="min-width: 200px">Peça</th>
                                        <th class="text-left" style="width: 100px">Qtd.</th>
                                        <th class="text-left" style="width: 140px">Valor unit.</th>
                                        <th class="text-left" style="width: 120px">Subtotal</th>
                                        <th style="width: 48px"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(part, index) in dataset.data.parts" :key="part.uid">
                                        <td class="py-2">
                                            <v-select dense outlined hide-details :items="resources.partStocks"
                                                :item-text="partLabel" item-value="id" v-model="part.part_stock_id"
                                                @change="onPartSelection(part, $event)"
                                                placeholder="Selecione..."></v-select>
                                        </td>
                                        <td class="py-2">
                                            <v-text-field dense outlined hide-details type="number" min="1"
                                                v-model="part.quantity"></v-text-field>
                                        </td>
                                        <td class="py-2">
                                            <v-text-field dense outlined hide-details type="number" prefix="R$"
                                                min="0" step="0.01" v-model="part.unit_price"></v-text-field>
                                        </td>
                                        <td class="py-2">
                                            <span class="body-2 font-weight-medium">{{ formatCurrency(calcPartTotal(part)) }}</span>
                                        </td>
                                        <td class="py-2">
                                            <v-btn icon x-small color="error" @click="removePartRow(index)">
                                                <v-icon small>mdi-delete-outline</v-icon>
                                            </v-btn>
                                        </td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                            <v-alert v-else type="info" dense text class="mt-2">Nenhuma peça adicionada.</v-alert>

                            <v-sheet outlined rounded class="pa-3 mt-4">
                                <v-row dense>
                                    <v-col cols="4" class="text-center">
                                        <div class="caption grey--text">Peças</div>
                                        <div class="body-2 font-weight-medium">{{ formatCurrency(partsTotal) }}</div>
                                    </v-col>
                                    <v-col cols="4" class="text-center">
                                        <div class="caption grey--text">Mão de obra + Externo</div>
                                        <div class="body-2 font-weight-medium">{{ formatCurrency(toNum(dataset.data.labor_cost) + toNum(dataset.data.external_cost)) }}</div>
                                    </v-col>
                                    <v-col cols="4" class="text-center">
                                        <div class="caption grey--text">Total estimado</div>
                                        <div class="text-subtitle-1 font-weight-bold primary--text">{{ formatCurrency(totalEstimate) }}</div>
                                    </v-col>
                                </v-row>
                            </v-sheet>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-form>
    </v-container>
</template>

<script>
import axios from 'axios'

const formatter = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' })

export default {
    name: 'CorrectiveDetails',

    data: () => ({
        page: {
            title: '',
            isNew: true,
        },
        dataset: {
            data: {
                vehicle_id: null,
                supplier_id: null,
                maintenance_type: null,
                maintenance_status: 'open',
                odometer: null,
                started_at: null,
                finished_at: null,
                reported_issue: '',
                diagnosis: '',
                work_performed: '',
                notes: '',
                labor_cost: 0,
                external_cost: 0,
                parts: [],
            },
            breadcrumbItems: [],
            loading: false,
        },
        dataForm: {
            validForm: true,
        },
        resources: {
            vehicles: [],
            suppliers: [],
            partStocks: [],
            maintenanceTypes: [],
            statuses: [],
        },
    }),

    computed: {
        partsTotal() {
            return (this.dataset.data.parts || []).reduce((sum, p) => sum + this.calcPartTotal(p), 0)
        },
        totalEstimate() {
            return this.partsTotal + this.toNum(this.dataset.data.labor_cost) + this.toNum(this.dataset.data.external_cost)
        },
    },

    created() {
        this.loadData()
    },

    methods: {
        async loadData() {
            this.setPage()
            this.listBreadCrumbItems()
            await this.loadResources()

            if (!this.page.isNew) {
                await this.load()
            }
        },

        goBack() {
            this.$router.replace('/manutencoes/corretivas')
        },

        setPage() {
            this.page.isNew = this.$route.params.id === 'novo'
            this.page.title = this.page.isNew ? 'Nova manutenção corretiva' : 'Editar manutenção corretiva'
        },

        listBreadCrumbItems() {
            this.dataset.breadcrumbItems = [
                { text: 'Homepage', disabled: false, to: '/home', exact: true },
                { text: 'Manutenções', disabled: false, to: '/manutencoes', exact: true },
                { text: 'Corretivas', disabled: false, to: '/manutencoes/corretivas', exact: true },
                { text: this.page.isNew ? 'Nova corretiva' : 'Editar corretiva', disabled: true, exact: true },
            ]
        },

        toNum(v) {
            const n = Number(v)
            return Number.isFinite(n) ? n : 0
        },

        formatCurrency(value) {
            return formatter.format(this.toNum(value))
        },

        calcPartTotal(part) {
            return this.toNum(part.quantity) * this.toNum(part.unit_price)
        },

        vehicleLabel(item) {
            if (!item) return ''
            return `${item.plate || 'Sem placa'} - ${item.brand || ''} ${item.model || ''}`.trim()
        },

        partLabel(item) {
            if (!item) return ''
            const sku = item.sku ? ` (${item.sku})` : ''
            return `${item.name}${sku} | Estoque: ${item.current_quantity}`
        },

        onPartSelection(part, partId) {
            if (!partId || part.unit_price > 0) return
            const selected = (this.resources.partStocks || []).find((s) => s.id === partId)
            if (selected) part.unit_price = selected.average_cost || 0
        },

        addPartRow() {
            if (!this.dataset.data.parts) this.dataset.data.parts = []
            this.dataset.data.parts.push({
                uid: `${Date.now()}-${Math.random()}`,
                part_stock_id: null,
                quantity: 1,
                unit_price: 0,
            })
        },

        removePartRow(index) {
            this.dataset.data.parts.splice(index, 1)
        },

        async loadResources() {
            try {
                const { data } = await axios.get('/api/v2/maintenance/corrective/resources')
                this.resources = data?.content || this.resources
            } catch (error) {
                this.$dialog.notify.error(this.$codes ? this.$codes(error) : 'Erro ao carregar recursos.', {
                    position: 'top-right', timeout: 5000,
                })
            }
        },

        dateToSql(value) {
            if (!value) return null
            const date = new Date(value)
            if (Number.isNaN(date.getTime())) return null
            const pad = (n) => String(n).padStart(2, '0')
            return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
        },

        dateToInput(value) {
            if (!value) return null
            const date = new Date(value)
            if (Number.isNaN(date.getTime())) return null
            const pad = (n) => String(n).padStart(2, '0')
            return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`
        },

        async load() {
            this.dataset.loading = true
            try {
                const { data } = await axios.get(`/api/v2/maintenance/corrective/${this.$route.params.id}`)
                const item = data?.content || {}

                this.dataset.data = {
                    vehicle_id: item.vehicle_id || null,
                    supplier_id: item.supplier_id || null,
                    maintenance_type: item.maintenance_type || 2,
                    maintenance_status: item.maintenance_status || 'open',
                    odometer: item.odometer,
                    started_at: this.dateToInput(item.started_at),
                    finished_at: this.dateToInput(item.finished_at),
                    reported_issue: item.reported_issue || '',
                    diagnosis: item.diagnosis || '',
                    work_performed: item.work_performed || '',
                    notes: item.notes || '',
                    labor_cost: item.labor_cost || 0,
                    external_cost: item.external_cost || 0,
                    parts: (item.parts || []).map((part) => ({
                        uid: `loaded-${part.id}`,
                        part_stock_id: part.part_stock_id,
                        quantity: part.quantity,
                        unit_price: part.unit_price,
                    })),
                }
            } catch (error) {
                this.$dialog.notify.error(this.$codes ? this.$codes(error) : 'Erro ao carregar manutenção corretiva.', {
                    position: 'top-right', timeout: 5000,
                })
                this.goBack()
            } finally {
                this.dataset.loading = false
            }
        },

        buildPayload() {
            return {
                vehicle_id: this.dataset.data.vehicle_id,
                supplier_id: this.dataset.data.supplier_id || null,
                maintenance_type: this.dataset.data.maintenance_type || 2,
                maintenance_status: this.dataset.data.maintenance_status || 'open',
                odometer: this.dataset.data.odometer ? Number(this.dataset.data.odometer) : null,
                labor_cost: this.toNum(this.dataset.data.labor_cost),
                external_cost: this.toNum(this.dataset.data.external_cost),
                started_at: this.dateToSql(this.dataset.data.started_at),
                finished_at: this.dateToSql(this.dataset.data.finished_at),
                reported_issue: this.dataset.data.reported_issue || null,
                diagnosis: this.dataset.data.diagnosis || null,
                work_performed: this.dataset.data.work_performed || null,
                notes: this.dataset.data.notes || null,
                parts: (this.dataset.data.parts || [])
                    .filter((p) => p.part_stock_id && this.toNum(p.quantity) > 0)
                    .map((p) => ({
                        part_stock_id: p.part_stock_id,
                        quantity: this.toNum(p.quantity),
                        unit_price: this.toNum(p.unit_price),
                    })),
            }
        },

        async save() {
            if (!this.$refs.form.validate()) return

            if (!this.dataset.data.vehicle_id) {
                this.$dialog.notify.error('Selecione o veículo para abrir a corretiva.', { position: 'top-right', timeout: 5000 })
                return
            }

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja salvar a manutenção corretiva?',
                title: 'Salvar corretiva',
                actions: { false: 'Cancelar', true: 'Salvar' },
            })

            if (!proceedAction) return

            this.dataset.loading = true

            try {
                await axios.post('/api/v2/maintenance/corrective', this.buildPayload())

                this.$dialog.notify.info('Manutenção corretiva criada com sucesso.', { position: 'top-right', timeout: 2000 })

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes ? this.$codes(error) : 'Erro ao criar manutenção corretiva.', {
                    position: 'top-right', timeout: 5000,
                })
            } finally {
                this.dataset.loading = false
            }
        },

        async update() {
            if (!this.$refs.form.validate()) return

            if (!this.dataset.data.vehicle_id) {
                this.$dialog.notify.error('Selecione o veículo da corretiva.', { position: 'top-right', timeout: 5000 })
                return
            }

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja atualizar a manutenção corretiva?',
                title: 'Atualizar corretiva',
                actions: { false: 'Cancelar', true: 'Atualizar' },
            })

            if (!proceedAction) return

            this.dataset.loading = true

            try {
                await axios.patch(`/api/v2/maintenance/corrective/${this.$route.params.id}`, this.buildPayload())

                this.$dialog.notify.info('Manutenção corretiva atualizada com sucesso.', { position: 'top-right', timeout: 2000 })

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes ? this.$codes(error) : 'Erro ao atualizar manutenção corretiva.', {
                    position: 'top-right', timeout: 5000,
                })
            } finally {
                this.dataset.loading = false
            }
        },
    },
}
</script>
